import React from "react";

const Modal = ({
  title,
  onClose,
  onSubmit,
  submitButtonText,
  showCancel,
  showSubmitButton,
  children,
  className = "",
  submitButtonClass = "bg-indigo-600 hover:bg-indigo-700 text-white",
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">

      <div
        className={`relative w-full max-w-lg max-h-[95vh] rounded-xl bg-white shadow-xl p-6 ${className}`}
      >

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-slate-400 hover:text-slate-700 transition"
        >
          <i className="fas fa-times text-lg"></i>
        </button>

        {/* Title */}
        {title && (
          <h2 className="text-lg font-semibold text-slate-800 mb-4">
            {title}
          </h2>
        )}

        <form onSubmit={onSubmit} className="space-y-4">

          {children}

          {(showCancel || showSubmitButton) && (
            <div className="flex justify-end gap-2 pt-2">

              {showCancel && (
                <button
                  type="button"
                  onClick={onClose}
                  className="px-4 py-2 rounded-lg bg-slate-200 text-slate-700 hover:bg-slate-300 transition"
                >
                  Cancel
                </button>
              )}

              {showSubmitButton && (
                <button
                  type="submit"
                  className={`px-4 py-2 rounded-lg transition ${submitButtonClass}`}
                >
                  {submitButtonText}
                </button>
              )}

            </div>
          )}

        </form>
      </div>
    </div>
  );
};

export default Modal;